import React from 'react';
import { Container } from 'reactstrap';
import WhatsappModule from '../../features/whatsapp/WhatsappModule';
import '../../features/whatsapp/whatsapp.scss';

const Whatsapp = () => {
    document.title = "Whatsapp | Tren Taita Imbabura";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <WhatsappModule />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Whatsapp;
